/*var Map = {
    element:'map',
    init:function(key){
        $.ajax({
            url: 'https://maps.googleapis.com/maps/api/js?key='+key+'&callback=Map.embed',
            dataType: "script"
        });
    },	
    embed:function(styling,lat,log){
        var the_center_point = {lat: lat, lng: log};
        var map = new google.maps.Map(document.getElementById(Map.element), {
            zoom: 15,
            center: the_center_point
        });
        var marker = new google.maps.Marker({
            position: the_center_point,
            map: map
        });
    }

}*/ 